import { useQuery } from "@tanstack/react-query";

import { getPricesCategories } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const getPriceCategoriesQueryKey = () => ["PRICE_CATEGORIES_QUERY"];

export function usePriceCategoriesQuery() {
  return useQuery({
    queryKey: getPriceCategoriesQueryKey(),
    queryFn: processResponse(() => getPricesCategories(0, 100)),
  });
}
